<div class="route-progress" *ngIf="navigating()" role="progressbar" aria-label="Chargement de la page"></div>
<p-toast key="toast" position="bottom-right" ></p-toast>
<div class="aglo-workspace" [class.agent-open]="agentOpened && showAgentIa"><router-outlet /></div>
<app-agent-ia *ngIf="showAgentIa" (openedChange)="agentOpened = $event"></app-agent-ia>

<!-- Need Pro Modal -->
<app-user-on-without-license-modal></app-user-on-without-license-modal>
<app-user-on-pro-license-modal></app-user-on-pro-license-modal>
<app-user-on-pro-license-post-project-modal></app-user-on-pro-license-post-project-modal>
<app-user-on-pro-license-post-library-modal></app-user-on-pro-license-post-library-modal>
<app-cstb-license-modal></app-cstb-license-modal>
